import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import { articleList } from '@/mocks/article';
import { articlesListSchema } from '@/mocks/schema/articlesList';

export default function ArticlesListPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <title>攻略资讯 - 2pg·com 最新游戏攻略与平台资讯</title>
      <meta
        name="description"
        content="2pg·com 最新游戏攻略、平台资讯、注册登录指南、账户安全解读等内容，帮助您快速了解平台并获得最佳游戏体验。"
      />
      <link rel="canonical" href="https://2pg.com/articles" />
      <SchemaOrg schemas={articlesListSchema} />

      <Navbar />
      <main className="pt-16">
        <section className="relative h-[280px] md:h-[320px] flex items-end overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20background%20with%20scattered%20papers%20and%20soft%20warm%20spotlights%2C%20premium%20news%20and%20blog%20atmosphere%2C%20rich%20textured%20surface%20with%20subtle%20golden%20highlights%2C%20sophisticated%20magazine%20aesthetic&width=1600&height=500&seq=articles-hero&orientation=landscape"
              alt="攻略资讯"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/60"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pb-10">
            <nav className="text-sm mb-3" aria-label="面包屑导航">
              <ol className="flex items-center gap-2 text-white/70">
                <li itemScope itemType="https://schema.org/ListItem">
                  <Link itemProp="item" to="/" className="hover:text-white transition-colors cursor-pointer">
                    <span itemProp="name">首页</span>
                  </Link>
                  <meta itemProp="position" content="1" />
                </li>
                <li className="text-white/40">/</li>
                <li itemScope itemType="https://schema.org/ListItem" className="text-white">
                  <span itemProp="name">攻略资讯</span>
                  <meta itemProp="position" content="2" />
                </li>
              </ol>
            </nav>
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-white">攻略资讯</h1>
          </div>
        </section>

        <section className="py-12 bg-background-50">
          <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articleList.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-700">{article.category}</span>
                      <span className="text-xs text-foreground-500">{article.date}</span>
                    </div>
                    <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">{article.excerpt}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-foreground-500">{article.readTime}阅读</span>
                      <span className="text-xs text-foreground-500">{article.views}次阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}